import { render, staticRenderFns } from "./my.vue?vue&type=template&id=6675926e&scoped=true&"
import script from "./my.vue?vue&type=script&lang=js&"
export * from "./my.vue?vue&type=script&lang=js&"
import style0 from "./my.vue?vue&type=style&index=0&id=6675926e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6675926e",
  null
  
)

export default component.exports